var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useCallback } from 'react';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { MinusIcon, PlusIcon } from '../../icons/';
var AccordionSummary = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = useState(false), expanded = _b[0], setExpanded = _b[1];
    var handleExpansion = useCallback(function () {
        setExpanded(function (prevExpanded) { return !prevExpanded; });
    }, []);
    return (React.createElement(MuiAccordionSummary, __assign({ expandIcon: expanded ? React.createElement(MinusIcon, null) : React.createElement(PlusIcon, null), onClick: handleExpansion }, props), children));
};
export default AccordionSummary;
//# sourceMappingURL=AccordionSummary.js.map